import React, { createContext, useContext, useState, ReactNode } from "react";

type DisableContextValue = {
  allDisabled: boolean;
  disableAllFor: (ms: number) => void;
};

const DisableContext = createContext<DisableContextValue | undefined>(undefined);

export function ButtonDisableProvider({ children }: { children: ReactNode }) {
  const [allDisabled, setAllDisabled] = useState(false);

  const disableAllFor = (ms: number) => {
    setAllDisabled(true);
    setTimeout(() => setAllDisabled(false), ms);
  };

  return (
    <DisableContext.Provider value={{ allDisabled, disableAllFor }}>
      {children}
    </DisableContext.Provider>
  );
}

export function useButtonDisable() {
  const ctx = useContext(DisableContext);
  if (!ctx) throw new Error("useButtonDisable must be used within <ButtonDisableProvider>");
  return ctx;
}
